import httpService from "./http.service";

class UserFlowService {
  getSummary = () => {
    return httpService.get("/user-flow/summary");
  };

  getUserDetails = (userId) => {
    return httpService.get(`/user-flow/users/${userId}`);
  };
}

const userFlowService = new UserFlowService();
export default userFlowService;
